import {PricingItem} from "../../../../domain/in/quote/pricing-item/pricing-item";
import {DeviceConsumablePricingItem} from "../../../../domain/in/quote/pricing-item/device-consumable-pricing-item";
import {bigToString, parseBig} from "../../../../utils/math-utils";
import {EnumPricingItemType} from "../../../../domain/in/quote/pricing-item/pricing-item-type";
import {DevicePricingItem} from "../../../../domain/in/quote/pricing-item/device-pricing-item";
import {arrayMove} from "../../../../utils/array-utils";
import {Big} from "big.js";
import {ConsumablePricingItem} from "../../../../domain/in/quote/pricing-item/consumable-pricing-item";

export const CONSUMABLE_SUP_PREFIX = ' SUP';

export class ContractViewSynthesisReorganizationService {

    getReorganizedPricingItems(pricingItems: PricingItem[]): PricingItem[] {
        let pricingItemsToUpdate: PricingItem[] = [];
        pricingItems.map(pi => {
            if (pi.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
                const franchise = (pi as DeviceConsumablePricingItem).franchise ? (pi as DeviceConsumablePricingItem).franchise : 1;
                const result = new Big(pi.userInputs.consumableQuantity).minus(new Big(pi.userInputs.quantity).mul(franchise));
                if (result.gt(new Big(0))) {

                    let newPricingItem = this.getNewDeviceConsumable(pi) as ConsumablePricingItem;

                    pricingItemsToUpdate.push(newPricingItem);

                    let newConsumable = this.getNewConsumable(pi, result) as ConsumablePricingItem;
                    pricingItemsToUpdate.push(newConsumable);
                }
            }
        });
        return this.organizePricingItems(pricingItems, pricingItemsToUpdate);
    }

    private organizePricingItems(selectedPricingItems: PricingItem[], pricingItemsToUpdate: PricingItem[]) {
        let newPricingItems = [...selectedPricingItems];
        if (pricingItemsToUpdate.length) {
            let parentIndex: number;
            pricingItemsToUpdate.forEach(pi => {
                const articleIndex = newPricingItems.findIndex(element => element.id == pi.id);
                if (articleIndex !== -1) {
                    parentIndex = articleIndex;
                    newPricingItems[articleIndex] = pi;
                } else {
                    newPricingItems.push(pi);
                    const consumableIndex = newPricingItems.findIndex(element => element.id == pi.id);
                    arrayMove(newPricingItems, consumableIndex, parentIndex + 1);
                }
            });
        }
        return newPricingItems;
    }

    private getNewConsumable(pricingItem: DeviceConsumablePricingItem, result: Big): ConsumablePricingItem {
        let consumableUserInputs = {...pricingItem.userInputs};
        consumableUserInputs['consumableQuantity'] = Number(result);

        const newConsumable = {...pricingItem.consumable};
        newConsumable.label = pricingItem.consumable.label.concat(CONSUMABLE_SUP_PREFIX);

        let consumablePricingItem = new ConsumablePricingItem();
        consumablePricingItem.consumable = newConsumable;
        consumablePricingItem.id = pricingItem.id.toString().concat(CONSUMABLE_SUP_PREFIX);
        consumablePricingItem.consumable = newConsumable;
        consumablePricingItem.userInputs = consumableUserInputs;
        consumablePricingItem.family = pricingItem.family;
        consumablePricingItem.isValid = pricingItem.isValid;
        consumablePricingItem.id = pricingItem.id.toString().concat(CONSUMABLE_SUP_PREFIX);
        consumablePricingItem.pricingItemType = EnumPricingItemType.CONSUMABLE;
        consumablePricingItem.consumableExtraPrice = pricingItem.consumableExtraPrice;
        consumablePricingItem.totalAppliedPrice = bigToString(parseBig(pricingItem.consumable.appliedPrice).mul(new Big(result)));
        return consumablePricingItem;

    }

    getSpecialPricingItemsCategories(pricingItems: PricingItem[]): Map<string, PricingItem[]> {
        let specialPricingItemsCategories = new Map();
        pricingItems.map(pi => {
            let subFamily = null;
            if (pi.family !== 'WIP') {
                subFamily = 'OTHER';
            } else if (pi.pricingItemType == EnumPricingItemType.CONSUMABLE) {
                subFamily = (pi as ConsumablePricingItem).consumable.articleDetails.subFamily;
            } else {
                subFamily = (pi as DevicePricingItem).device.articleDetails.subFamily;
            }
                if (specialPricingItemsCategories.has(subFamily)) {
                    specialPricingItemsCategories.get(subFamily).push(pi);
                } else {
                    specialPricingItemsCategories.set(subFamily, [pi]);
                }

        });
        return specialPricingItemsCategories;
    }

    private getNewDeviceConsumable(pi: DeviceConsumablePricingItem): DeviceConsumablePricingItem {


        const franchise = pi.franchise ? pi.franchise : 1;
        const newQuantity = Number(new Big(pi.userInputs.quantity).mul(franchise));
        let deviceConsumableUserInputs = {...pi.userInputs};
        deviceConsumableUserInputs['consumableQuantity'] = newQuantity;


        let deviceConsumablePricingItem = new DeviceConsumablePricingItem();
        deviceConsumablePricingItem.id = pi.id;
        deviceConsumablePricingItem.device = pi.device;
        deviceConsumablePricingItem.consumable = pi.consumable;
        deviceConsumablePricingItem.consumableExtraPrice = pi.consumableExtraPrice;
        deviceConsumablePricingItem.specificities = pi.specificities;
        deviceConsumablePricingItem.franchise = pi.franchise;
        deviceConsumablePricingItem.discount = pi.discount
        deviceConsumablePricingItem.prefilledInputs = pi.prefilledInputs;
        deviceConsumablePricingItem.userInputs = deviceConsumableUserInputs;
        deviceConsumablePricingItem.family = pi.family;
        deviceConsumablePricingItem.isValid = pi.isValid;
        deviceConsumablePricingItem.pricingItemType = EnumPricingItemType.DEVICE_CONSUMABLE;
        deviceConsumablePricingItem.totalAppliedPrice = bigToString((parseBig(pi.device.appliedPrice).mul(new Big(pi.userInputs.quantity))).add(parseBig(pi.consumable.appliedPrice).mul(new Big(newQuantity))));


        return deviceConsumablePricingItem;
    }
}
